import { ClassAttributes, createElement, useContext, useEffect, FC } from 'react';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import { context as ConfigContext } from '../context/config';
import Screen from '../screen/SignedOutScreen';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SignedOutScreen: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const config = useContext(ConfigContext);

  const kaizenIdUrl = `${config.ID_WEB_URL}`;
  const kaizenIdWithRedirectUrl = `${config.ID_WEB_URL}?done=${window.location.href}`;
  const kaizenIdSignUpUrl = `${config.ID_WEB_URL}/sign_up?done=${window.location.href}`;

  useEffect(() => {
    if (location.href.match(/\/sign_up/)) {
      dependency.authenticationUsecase.redirectKaizenIdforSignUp(kaizenIdSignUpUrl);
    }
  }, []);

  return state.fatalError === null &&
    state.authentication.fetching === 0 &&
    state.authentication.signedInUser === null &&
    Object.keys(state.translations).length !== 0 ? (
    <Screen className={className} kaizenIdUrl={kaizenIdUrl} kaizenIdWithRedirectUrl={kaizenIdWithRedirectUrl} />
  ) : null;
};

export default SignedOutScreen;
